import {
    ableProps,
    ablePropsInit,
    events as baseEvents,
} from '../component-base/props';

export const props = () => [
    ...ableProps,
    {
        key: 'text',
        label: '链接文字',
        type: 'string',
    },
    {
        key: 'link',
        label: '跳转地址',
        type: 'string',
    },
];

export const init = () => ({
    ...ablePropsInit,
    text: '',
    link: '',
});

export const name = '链接节点';

export const component = 'mobile-general-form-node-link';

export const events = [
    // 'click',
    ...baseEvents,
];
